// Module
var code = "<h2 id=\"pheaa-financial-reports--trusts\">PHEAA Financial Reports &amp; Trusts</h2> <p>Read about what Financial Reports and Trusts PHEAA offers for the investment community.</p> ";
// Exports
export default code;